import React from 'react';
import { styled } from 'styled-components';
import { NAV_MENU_BREAKPOINT } from '@constants';
import AlgoliaSearch from './AlgoliaSearch';

const NavSearch = () => (
  <Wrapper>
    <AlgoliaSearch />
  </Wrapper>
);

export default NavSearch;

const Wrapper = styled.div`
  margin-top: 6px;
  width: 100%;
  max-width: 1176px;

  @media (max-width: ${NAV_MENU_BREAKPOINT}px) {
    margin-top: 0px;
    padding: 0 24px;
  }
`;
